import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import {BrowserRouter} from 'react-router-dom';
import {Provider} from 'react-redux';
import App from './App';
import Player from './utils/Player';
// import registerServiceWorker from './registerServiceWorker';
import store from './store';
import createHistory from 'history/createBrowserHistory';

createHistory();
const player = new Player({store});
ReactDOM.render(
  <Provider store={store}>
  <BrowserRouter>
    <App player={player}/>
  </BrowserRouter>
</Provider>, document.getElementById('root'));

// registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js